var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,18.1L22,19.6l-9-9l6.1-6.1l-2.7-2.7L16.1,2c-0.1,0.1-3.3,2.3-6-0.5L9.8,1.2l-8.9,8.9l6.3,6.3l5.1-5.1l9,9 l-1.5,1.5l10.4,10.4l3.8-3.8L23.5,18.1z M2.3,10.1l7.5-7.5c2.6,2.3,5.6,1,6.6,0.4l1.4,1.4L7.2,15L2.3,10.1z M21.2,21.8l2.4-2.4l9,9 l-2.4,2.4L21.2,21.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.a75e4a6f279a27c69cb7a3a3a60770ba.svg";
export { ForwardRef as ReactComponent };